import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../auth";
import { api } from "../api";
import { pushStatus, subscribePush, unsubscribePush } from "../push";

export default function Settings() {
  const { user, logout } = useAuth();
  const [status, setStatus] = useState<string>("…");
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState<string | null>(null);

  useEffect(() => { pushStatus().then(setStatus); }, []);

  async function activate() {
    setBusy(true); setMsg(null);
    try {
      const ok = await subscribePush();
      setStatus(await pushStatus());
      setMsg(ok ? "Notifications activées." : "Permission refusée.");
    } catch (e) {
      setMsg(e instanceof Error ? e.message : "Erreur");
    } finally { setBusy(false); }
  }

  async function deactivate() {
    setBusy(true); setMsg(null);
    try {
      await unsubscribePush();
      setStatus(await pushStatus());
      setMsg("Désinscrit.");
    } finally { setBusy(false); }
  }

  async function test() {
    await api("/push/test", { method: "POST" });
    setMsg("Notification de test envoyée à l'autre utilisateur.");
  }

  return (
    <>
      <h2>Réglages</h2>

      <div className="card">
        <div className="section-h" style={{ margin: 0 }}>Compte</div>
        <div style={{ marginTop: 6 }}>
          <b>{user?.identifier}</b> — {user?.display_name}
        </div>
        <div className="tiny">{user?.role === "admin" ? "Administrateur" : "Utilisateur"}</div>
        <div style={{ height: 12 }} />
        <Link to="/me/password" className="btn btn-ghost full">
          Changer mon mot de passe
        </Link>
      </div>

      {user?.role === "admin" && (
        <div className="card">
          <div className="section-h" style={{ margin: 0 }}>Administration</div>
          <p className="muted" style={{ marginTop: 6 }}>
            Créer / réinitialiser / désactiver des comptes.
          </p>
          <Link to="/admin" className="btn btn-secondary full">
            Ouvrir le panneau d'administration
          </Link>
        </div>
      )}

      <div className="card">
        <div className="section-h" style={{ margin: 0 }}>Notifications PWA</div>
        <div className="tiny" style={{ marginTop: 6 }}>État : {status}</div>
        {msg && <div className="muted" style={{ marginTop: 6 }}>{msg}</div>}
        <div className="row" style={{ gap: 8, marginTop: 12, flexWrap: "wrap" }}>
          <button className="btn btn-primary sm" onClick={activate} disabled={busy}>Activer</button>
          <button className="btn btn-ghost sm" onClick={deactivate} disabled={busy}>Désactiver</button>
          <button className="btn btn-secondary sm" onClick={test} disabled={busy}>Test</button>
        </div>
        <p className="tiny" style={{ marginTop: 10 }}>
          Sur iPhone : ajoutez d'abord e-flux à l'écran d'accueil (icône Partager → « Sur l'écran d'accueil »), puis ouvrez l'app installée pour activer les notifications.
        </p>
      </div>

      <div className="card">
        <div className="section-h" style={{ margin: 0 }}>Session</div>
        <div style={{ height: 10 }} />
        <button className="btn btn-ghost full" onClick={logout}>
          Se déconnecter
        </button>
      </div>
    </>
  );
}
